<template>
  <Dialog v-model:open="dialogState.isOpen" @update:open="handleOpenChange">
    <DialogContent class="sm:max-w-[425px]">
      <DialogHeader>
        <DialogTitle>{{ dialogState.title }}</DialogTitle>
        <DialogDescription>
          {{ dialogState.description }}
        </DialogDescription>
      </DialogHeader>
      <DialogFooter class="flex gap-2">
        <Button variant="outline" @click="handleCancel">
          {{ dialogState.cancelText || $t('cart.clearCart.cancel') }}
        </Button>
        <Button @click="handleConfirm">
          {{ dialogState.confirmText || $t('cart.clearCart.confirm') }}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { useConfirmDialog } from '~/composables/useConfirmDialog'

const {
  state: dialogState,
  handleConfirm,
  handleCancel,
  handleOpenChange
} = useConfirmDialog()
</script>
